import { NextTable } from '@core/table';

import { useTelegramBotUsersTable } from '../hooks';

export const BoxTransfersTable = () => {
  const { columns, context } = useTelegramBotUsersTable();

  return <NextTable context={context} columns={columns} />;
};
